import { Helmet } from "react-helmet";

export default function HomePageMetaTags() {
  return (
    <>
      <Helmet>
        <title>Paysfer eMart</title>
        <meta
          name="description"
          content="Online marketplace sells all categories of goods since 2020, NY based. Multi-vendor, new platform, custom Seller shops. Low seller fees, lower prices, shipping"
        />
        <link rel="canonical" href="https://www.paysfer.com/" />
        {/* Open Graph tags */}
        <meta property="og:title" content="Paysfer eMart" />
        <meta
          property="og:description"
          content="Online marketplace sells all categories of goods since 2020, NY based. Multi-vendor, new platform, custom Seller shops. Low seller fees, lower prices, shipping"
        />
        <meta property="og:url" content="https://www.paysfer.com/" />
        <meta
          property="og:image"
          content="https://storage.googleapis.com/content.paysfer.com/banner/white-logo.png"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_US" />

        {/* JSON-LD for LocalBusiness */}
        <script type="application/ld+json">
          {`{
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Paysfer emart",
          "image": "https://storage.googleapis.com/content.paysfer.com/banner/white-logo.png",
          "@id": "https://www.paysfer.com/",
          "url": "https://www.paysfer.com/",
          "telephone": "917-744-0056",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "154 West 14th",
            "addressLocality": "New York",
            "addressRegion": "NY",
            "postalCode": "10011",
            "addressCountry": "US"
          },
          "description": "Online marketplace sells all categories of goods since 2020, NY based. Multi-vendor, new platform, custom Seller shops. Low seller fees, lower prices, shipping",
          "openingHours": "Mo-Su 09:00-21:00",
          "priceRange": "$$"
        }`}
        </script>
        {/* JSON-LD for Organization */}
        <script type="application/ld+json">
          {`{
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Paysfer emart",
          "alternateName": "Paysfer",
          "url": "https://www.paysfer.com/",
          "logo": "https://storage.googleapis.com/content.paysfer.com/banner/white-logo.png"
        }`}
        </script>
      </Helmet>
    </>
  );
}
